import styled from 'styled-components';
export const PricingLineContent = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: flex-end;
`;
